(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-media-gallery')) customElements.define('product-media-gallery', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track = this.querySelector('[data-gallery-track]');
      this.items = [...this.track.querySelectorAll('[data-media-id]')];
      this.mobile = matchMedia('(max-width: 899px)');
      const dialog = this.querySelector('dialog');
      const update = () => {
        if (!this.mobile.matches || !this.items.length) return;
        const bounds = this.track.getBoundingClientRect();
        const active = this.items.reduce((nearest, item) => Math.abs(item.getBoundingClientRect().left - bounds.left) < Math.abs(nearest.getBoundingClientRect().left - bounds.left) ? item : nearest);
        this.querySelectorAll('[data-gallery-thumbnail]').forEach(link => link.setAttribute('aria-current', String(link.dataset.galleryThumbnail === active.dataset.mediaId)));
        const counter = this.querySelector('[data-gallery-current]');
        if (counter) counter.textContent = String(this.items.indexOf(active) + 1);
        this.items.filter(item => item !== active).forEach(item => item.querySelectorAll('video').forEach(video => video.pause()));
      };
      this.track.addEventListener('scroll', () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(update); }, options);
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-gallery-thumbnail]');
        if (thumb) { event.preventDefault(); this.showMedia(thumb.dataset.galleryThumbnail); }
        const zoom = event.target.closest('[data-gallery-zoom]');
        if (zoom) {
          const original = zoom.querySelector('img');
          const image = dialog.querySelector('img');
          image.src = original.currentSrc || original.src;
          image.srcset = original.srcset;
          image.sizes = '1600px';
          image.alt = original.alt;
          dialog.querySelector('[data-zoom-toggle]').setAttribute('aria-pressed', 'false');
          dialog.showModal();
        }
        if (event.target.closest('[data-gallery-close]')) dialog.close();
        const toggle = event.target.closest('[data-zoom-toggle]');
        if (toggle) toggle.setAttribute('aria-pressed', String(toggle.getAttribute('aria-pressed') !== 'true'));
      }, options);
      this.closest('[data-product-root]').addEventListener('product:media-change', event => this.showMedia(event.detail.mediaId), options);
      const initial = () => this.showMedia(this.querySelector('.product-gallery__item--primary')?.dataset.mediaId, false);
      this.mobile.addEventListener('change', initial, options);
      requestAnimationFrame(initial);
    }
    showMedia(id, animate = true) {
      const item = this.items.find(media => media.dataset.mediaId === String(id));
      if (!item) return;
      this.querySelectorAll('[data-gallery-thumbnail]').forEach(link => link.setAttribute('aria-current', String(link.dataset.galleryThumbnail === String(id))));
      if (!this.mobile.matches) {
        this.items.forEach(media => {
          media.classList.toggle('product-gallery__item--primary', media === item);
          if (media !== item) media.querySelectorAll('video').forEach(video => video.pause());
        });
        return;
      }
      const distance = item.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
      this.track.scrollBy({ left: distance, behavior: animate && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant' });
    }
    disconnectedCallback() { this.abort?.abort(); cancelAnimationFrame(this.frame); }
  });
  } catch(e) { console.error(e); }
})();

})();
